import { createAction, props, union } from '@ngrx/store';

import { GlobalBookingTravelClass } from '@fcom/core';
import { TripType } from '@fcom/core/interfaces';
import {
  DestinationSearchItem,
  DestinationSearchTripDates,
  DestinationSearchFilters,
  DestinationSearchFilterStateMeta,
} from '@fcom/destination-search/interfaces';
import { DestinationSearchBlockOffer } from '@fcom/cms';

export const setDestinationSearchSelection = createAction(
  '[DestinationSearchFilter] SetDestinationSearchSelection',
  props<{ selection: DestinationSearchFilters; meta: DestinationSearchFilterStateMeta }>()
);
export const removeRouteUpdate = createAction(
  '[DestinationSearchFilter] removeRouteUpdate',
  props<{ meta: DestinationSearchFilterStateMeta }>()
);
export const setTripDates = createAction(
  '[DestinationSearchFilter] SetTripDates',
  props<{ tripDates: DestinationSearchTripDates; meta: DestinationSearchFilterStateMeta }>()
);
export const setTripType = createAction(
  '[DestinationSearchFilter] SetTripType',
  props<{ tripType: TripType; meta: DestinationSearchFilterStateMeta }>()
);
export const setTravelClass = createAction(
  '[DestinationSearchFilter] SetTravelClass',
  props<{ travelClass: GlobalBookingTravelClass; meta: DestinationSearchFilterStateMeta }>()
);
export const setSelectedDestinations = createAction(
  '[DestinationSearchFilter] SetSelectedDestinations',
  props<{ selectedDestinations: DestinationSearchItem[]; meta: DestinationSearchFilterStateMeta }>()
);
export const setFromLocationCode = createAction(
  '[DestinationSearchFilter] SetFromLocationCode',
  props<{ fromLocationCode: string; meta: DestinationSearchFilterStateMeta }>()
);
export const setRestrictToDestinations = createAction(
  '[DestinationSearchFilter] SetFromLocationCode',
  props<{ restrictToDestinations: string[]; meta: DestinationSearchFilterStateMeta }>()
);

export const setMaxPrice = createAction(
  '[DestinationSearchFilter] SetMaxPrice',
  props<{ maxPrice: number; meta: DestinationSearchFilterStateMeta }>()
);

export const setShowDirectFlightsOnly = createAction(
  '[DestinationSearchFilter] SetShowDirectFlightsOnly',
  props<{ showDirectFlightsOnly: boolean; meta: DestinationSearchFilterStateMeta }>()
);

export const setDestinationsBeforeFiltering = createAction(
  '[DestinationSearchFilter] SetDestinationsBeforeFiltering',
  props<{ destinationsBeforeFiltering: DestinationSearchBlockOffer[]; meta: DestinationSearchFilterStateMeta }>()
);

export const setRoundTripPrices = createAction(
  '[DestinationSearchFilter] SetRoundTripPrices',
  props<{ roundTripPrices: boolean; meta: DestinationSearchFilterStateMeta }>()
);

const all = union({
  setDestinationSearchSelection,
  removeRouteUpdate,
  setTripDates,
  setTripType,
  setTravelClass,
  setSelectedDestinations,
  setFromLocationCode,
  setRestrictToDestinations,
  setMaxPrice,
  setShowDirectFlightsOnly,
  setDestinationsBeforeFiltering,
  setRoundTripPrices,
});
export type ActionsUnion = typeof all;
